import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import { Row, Col, Table } from "antd";

@inject('store')
@observer
class RoomsRank extends Component {
    render() {
        const { revenue, profit } = this.props.store.allHotel;
        const columns = [{
            title: '排名',
            key: '排名',
            dataIndex: 'index',
            width: 80,
            render: (text, record, i) => {
                return (
                    <div className={`rank rank${text}`}>{text}</div>
                )
            }
        }, {
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '总收入',
            dataIndex: 'revenue',
            key: 'revenue',
            width: 150,
            sorter: (a, b) => a.revenue - b.revenue,
            render: (text, record, i) => {
                return (
                    <span>￥{Number(text).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                )
            }
        }];
        const profitColumns = [{
            title: '排名',
            key: '排名',
            dataIndex: 'index',
            width: 80,
            render: (text, record, i) => {
                return (
                    <div className={`rank rank${text}`}>{text}</div>
                )
            }
        }, {
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '总利润',
            dataIndex: 'profit',
            key: 'profit',
            width: 150,
            sorter: (a, b) => a.profit - b.profit,
            render: (text, record, i) => {
                return (
                    <span>￥{Number(text).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                )
            }
        }];
        const pagination = {
            total: revenue.length,
            pageSize: 5
        };
        return (
            <div className="rooms">
                <Row>
                    <Col span={12}>
                        <div className="total_style">总收入排名 Total Revenue Ranking </div>
                        <Table
                            className="rank-table "
                            columns={columns}
                            dataSource={toJS(revenue)}
                            rowKey={(record, index) => record.id}
                            pagination={pagination}
                        />
                    </Col>
                    <Col span={12}>
                        <div className="total_style">经营利润排名 GOP Ranking</div>
                        <Table
                            className="rank-table "
                            columns={profitColumns}
                            dataSource={toJS(profit)}
                            rowKey={(record, index) => record.id}
                            pagination={pagination}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default RoomsRank;


// WEBPACK FOOTER //
// ./src/components/BI/headquarters/Rank.js